import { create } from 'zustand';

interface IStore {
  quizId: string | undefined;
  setQuizId: (quizId: string | undefined) => void;
}

export const useQuizDeletionModal = create<IStore>(set => ({
  quizId: undefined,
  setQuizId: (quizId: string | undefined) => set({ quizId })
}));
